import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Input from 'components/Input'
import Button from 'components/Button'
import ErrorBox from 'components/ErrorBox'
import SentResetPassword from 'pageComponents/SentResetPassword'
import validate, { tests } from 'utils/validate'
import { actions } from 'slices/app.slice'
import { path } from 'utils/const'
import styles from './resetPassword.module.scss'
import { images } from '../../../assets'
import BackComponent from "../../../components/BackComponent/BackComponent";

const ResetPassword = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { me } = useSelector((state) => state.app)

  // ------------------------------------
  // State
  // ------------------------------------
  const [input, setInput] = useState({
    email: me.authEmail || me.email || '',
  })
  const [error, setError] = useState({})
  const [resErr, setResError] = useState('')
  const [isLoading, setLoading] = useState(false)
  const [isOpen, setOpen] = useState(false)

  // ------------------------------------
  // Handlers
  // ------------------------------------
  const handleOnChange = ({ target: { name, value } }) => {
    setInput((prev) => ({ ...prev, [name]: value }))
    setError((prev) => ({ ...prev, [name]: '' }))
    setResError('')
  }

  const handleSubmit = async () => {
    // validation
    const result = validate(input, tests)
    setError(result.errors)
    if (result.isError) return

    setLoading(true)

    try {
      await dispatch(actions.resetPassword(input.email))
      setOpen(true)
      setResError('')
      setLoading(false)
    } catch (err) {
      setResError(err.message)
      setLoading(false)
    }
  }

  return (
    <div className={styles.root}>
      {resErr && <ErrorBox>{resErr}</ErrorBox>}
      <BackComponent title={'Change password'} />
      <div className={styles.logoDiv}>

        <img src={images.ydoLogo} className={styles.resetLogo} alt="logo" />
        <p className={styles.heading}>Your Doctors Online</p>
        <div className={styles.divSpace}>
          {/*
          <p className={styles.forgetPassword}>Forgot Password</p>
*/}

          {!(me.authEmail || me.email) && (
            <Input
              name="email"
              placeholder="email@example.com"
              value={input.email}
              onChange={handleOnChange}
              error={error.email}
            />
          )}
          <br />
          <Button
            label="Change Password"
            className={styles.sendButton}
            onClick={handleSubmit}
            isLoading={isLoading}
          />

          <SentResetPassword
            email={input.email}
            isOpen={isOpen}
            toggle={() => setOpen((prev) => !prev)}
            onSubmit={() => {
              navigate(-1)
              setOpen((prev) => !prev)
            }}
          />
        </div>
      </div>
    </div>
  )
}

ResetPassword.propTypes = {}
ResetPassword.defaultProps = {}

export default ResetPassword
